<script>
    import { authWellyMethods } from "@/state/helpers"
    import { apiCore }  from '../../../../constants'
    import axios from 'axios'

    export default {
        components: {},
        props: {
            idResto: {
                type: String,
                default: "",
            },
            nameResto: {
                type: String,
                default: "",
            }
        },
        data() {
            return {
                sucursales: null,
                infoResto: null,
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            getSucursales(){
                this.sucursales = null
                
                let url = `${apiCore}/api/welly/admin/resto/${this.idResto}/sucursales`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                        // eslint-disable-next-line
                        //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        //console.log(res)
                        this.sucursales = res.sucursales
                    } 
                })
            },
            getInfoResto(){
                let url = `${apiCore}/api/resto/${this.idResto}/info/admin`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                        // eslint-disable-next-line
                        //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        //console.log(res)
                        this.infoResto = res.resto
                    } 
                })
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user;

            
        },
        watch:{
            idResto(){
                this.getSucursales();
                this.getInfoResto()
            }
        }
    }
</script>

<template>

    <b-modal 
        id="sucursalesResto" 
        centered
        hide-footer="true"
        hide-header="true"
        size="lg"
        >
        
        <div class="row">
            <div class="col-md-12">
                <div class="card-welly">
                    <div class="row">
                        <div class="col-md-12 container-welly">
                            <h3 class="title-card">
                                Resto Principal - "{{nameResto}}"
                            </h3>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-8">
                                        <b>Dirección:</b> {{infoResto.address}}
                                    </div>
                                    <div class="col-md-8" v-if="infoResto.userEmail!=''">
                                        <b>Correo:</b> {{infoResto.userEmail}}
                                    </div>
                                    <div class="col-md-8" v-if="infoResto.passwordPrincipal != ''">
                                        <b>Contraseña:</b> {{infoResto.passwordPrincipal}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 container-welly" style="margin-top: 1em;" v-if="sucursales == null">
                            <h3 class="title-card">
                                SIN SUCURSALES
                            </h3>
                        </div>   
                        <div class="col-md-12 container-welly" style="margin-top: 1em;" v-if="sucursales != null">
                            <div class="row scroll1">

                                <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                    <h3 class="title-card">
                                        SUCURSALES
                                    </h3>
                                    <div class="table-responsive">
                                        <table class="table mb-0">
                                            <thead class="table-head">
                                                <tr>
                                                    <th style="width:5%;">No.</th>
                                                    <th style="width:25%;">Nombre</th>
                                                    <th style="width:30%;">Dirección</th>
                                                    <!--<th style="width:10%;">Tipo</th>-->
                                                    <th style="width:25%;">Credenciales</th>
                                                </tr>
                                            </thead>
                                            <tbody class="table-body">
                                                <tr v-for="(sucursal,index) in sucursales" :key="index">
                                                    <th>{{index + 1}}</th>
                                                    <th>
                                                        <b>{{sucursal.aliasSucursal}}</b>
                                                        <br/>
                                                        {{sucursal.name}}
                                                    </th>
                                                    <th>
                                                        {{sucursal.address}}
                                                        <br/>
                                                        <span style="font-size:0.7em;">{{sucursal.lat}}, {{sucursal.lng}}</span>
                                                    </th>
                                                    <!--
                                                    <th>
                                                        <img src="@/assets/images/special/ACC2_BLACK.svg" v-show="sucursal.glutenFree" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/VEGGIE_BLACK.svg" v-show="sucursal.veggie" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/CHEESE_BLACK.svg" v-show="sucursal.vegan" style="margin: 0 5px 0 0;" height="20"/>
                                                        <span v-show="!sucursal.glutenFree && !sucursal.veggie && !sucursal.vegan">Sin definir</span>
                                                    </th>
                                                    -->
                                                    <th>
                                                        <b>{{sucursal.userEmail}}</b>
                                                        <br/>
                                                        {{sucursal.validateWelly ? sucursal.passwordSucursal : 'Pendiente'}}
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                            <br/>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="right">
                    <b-button href="#" type="submit" variant="primary" @click="$bvModal.hide('sucursalesResto');" class="btn-primary">
                        Volver
                    </b-button>
                </div>
            </div>
        </div>


        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="$bvModal.hide('sucursalesResto');"
                >Close</b-button
            >
        </template>
    </b-modal>
    
</template>
